document.addEventListener('focusin', function (event) {
  var el = event.target;
  if (!el.classList || !el.classList.contains('nhm-input')) return;

  // Skip if inside offcanvas/modal where body scroll shouldn't change
  if (el.closest('.offcanvas, .modal')) return;

  if (!el.getBoundingClientRect) return;
  var rect = el.getBoundingClientRect();

  var header = document.querySelector('.site-header.sticky-top');
  var headerHeight = header ? header.getBoundingClientRect().height : 0;

  var targetTop = window.pageYOffset + rect.top - headerHeight - 112;
  if (targetTop < 0) targetTop = 0;

  try {
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  } catch (e) {
    window.scrollTo(0, targetTop);
  }
});
document.addEventListener('DOMContentLoaded', function () {
  try {
    var prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // 1) Scroll .nhm-input into view under the sticky header
    document.addEventListener('focusin', function (event) {
      var el = event.target;
      if (!el.classList || !el.classList.contains('nhm-input')) return;

      // Skip if inside offcanvas/modal where body scroll shouldn't change
      if (el.closest('.offcanvas, .modal')) return;
      if (!el.getBoundingClientRect) return;

      var rect = el.getBoundingClientRect();
      var header = document.querySelector('.site-header.sticky-top');
      var headerHeight = header ? header.getBoundingClientRect().height : 0;

      var targetTop = window.pageYOffset + rect.top - headerHeight - 112;
      if (targetTop < 0) targetTop = 0;

      try {
        if (prefersReducedMotion) {
          window.scrollTo(0, targetTop);
        } else {
          window.scrollTo({ top: targetTop, behavior: 'smooth' });
        }
      } catch (e) {
        window.scrollTo(0, targetTop);
      }
    });

  } catch (e) {
    if (window.console && console.warn) {
      console.warn('Theme focus/scroll script error:', e);
    }
  }
});
